import { AffordabilityDesign1 } from './designs/AffordabilityDesign1';
import { AffordabilityDesign2 } from './designs/AffordabilityDesign2';

type DesignName = 'dabadu' | 'equifax';

interface WidgetData {
  token: string;
  customClassName?: string;
  type: string;
  version: string;
  module?: string;
  design?: DesignName;
}

// export class AffordabilityBanner {

export class AffordabilityBanner {
  private widgetData: WidgetData;
  private bannerInstance: any;
  private containerElement!: HTMLDivElement;
  private language = 'en';
  private response: any;
  private primaryColor: string | undefined;
  private iframeId = 'credit-score-v2';

  constructor(widgetData: WidgetData) {
    this.widgetData = widgetData;

    // create banner instance selected by design
    const onOpen = this.openIframe.bind(this);
    if (this.widgetData.design === 'equifax') {
      this.bannerInstance = new AffordabilityDesign2(this.widgetData, onOpen);
    } else if (this.widgetData.design === 'dabadu') {
      this.bannerInstance = new AffordabilityDesign1(this.widgetData, onOpen);
    } else {
      this.bannerInstance = new AffordabilityDesign2(this.widgetData, onOpen);
    }

    this.containerElement = this.bannerInstance.getContainer();

    // wire window messages for open/close and validation
    this.setupEventListeners();
  }

  render(targetElement: HTMLElement) {
    targetElement?.appendChild(this.containerElement);

    // optionally preload an iframe for faster open flows
    this.preloadIframe();
  }

  private preloadIframe() {
    if (document.getElementById(this.iframeId)) return;
    const iframe = document.createElement('iframe');
    iframe.name = this.iframeId;
    iframe.src = `https://widget-v1.dabadu.dev/credit-score/${this.widgetData.token}?domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;
    iframe.style.display = 'none';
    iframe.id = this.iframeId;
    document.body.appendChild(iframe);
  }

  private openIframe() {
    // remove existing
    this.closeIframe();

    const iframe = document.createElement('iframe');
    iframe.id = this.iframeId;
    iframe.name = this.iframeId;
    iframe.src = `https://widget-v1.dabadu.dev/credit-score/${this.widgetData.token}?domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;
    iframe.style.cssText = `
      width:100vw;height:100vh;border:none;position:fixed;top:0;left:0;z-index:1000000;display:block;
    `;
    document.body.appendChild(iframe);

    // lock body scroll
    document.body.style.overflow = 'hidden';
  }

  private closeIframe() {
    const el = document.getElementById(this.iframeId);
    if (el) {
      el.remove();
      document.body.style.overflow = '';
    }
  }

  private setupEventListeners() {
    window.addEventListener('message', (event) => {
      // if (!event || !event.data) return;
      try {
        const { type, res } = event.data;
        const moduleKey = this.widgetData.module || 'credit-score';

        if (!type?.startsWith(moduleKey)) return;
        if (res?.accessToken && res.accessToken !== this.widgetData.token) return;

        if (type === `${moduleKey}-modal-close`) {
          this.closeIframe();
          return;
        }

        if (
          type === `${moduleKey}-modal-open` &&
          res?.success &&
          res?.widgetName === 'Credit Score' &&
          res?.type === 'banner'
        ) {
          // validation response from host/server -> update banner
          this.response = res;
          this.language = res?.language || 'en';
          this.primaryColor = res?.primaryColor || undefined;

          if (typeof this.bannerInstance.setLanguage === 'function') {
            this.bannerInstance.setLanguage(this.language);
          }
          if (typeof this.bannerInstance.setResponse === 'function') {
            this.bannerInstance.setResponse(this.response);
          }
          if (typeof this.bannerInstance.setPrimaryColor === 'function') {
            this.bannerInstance.setPrimaryColor(this.primaryColor || '#000');
          }
          if (typeof this.bannerInstance.buildBanner === 'function') {
            this.bannerInstance.buildBanner(this.response);
          }

          // make banner visible if style uses visibility hidden initially
          try {
            this.containerElement.style.visibility = 'visible';
          } catch (e) {
            // ignore
          }
        }
      } catch (err) {
        // ignore malformed postMessage payloads
        // console.warn('AffordabilityBanner message handler', err);
      }
    });
  }
}
